import { ArticleCode } from "../article-code/article-code.model";
import { Document } from "../device-documentation/device-documentation.model";
import { Tag } from "../utils.model";

// Interface for paginated response with headers
export interface PaginatedResponse<T> {
  data: T[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

export class Device {
  constructor(
    public entityId?: string,
    public id?: string,
    public internalId?: string,
    public serialNumber?: string,
    public ownerId?: string,
    public creationDate?: Date,
    public activationDate?: Date,
    public purchaseDate?: Date,
    public country?: string,
    public status?: string,
    public deviceType?: string,
    public deviceModel?: string,
    public device?: string,
    public deviceSystem?: string,
    public model?: string,
    public articleId?: number,
    public serialNumberId?: number,
    public snDevicetype?: string,
    public certificatePath?: string,
    public articleCode?: string,
    public plantId?: string,
    public tags?: Tag[],
    // public applications?: string[],
    public userNotes?: string,
    public name?: string,
    public description?: string,
    public firmwareVersion?: string,
    public hardwareVersion?: string,
    public warrantyExpiration?: Date,
    public warrantyName?: string,
    public warrantyPlus?: string,
    public warrantyStatus?: string,
    public documents?: Document[]
  ) {}
}

export class DeviceNameSerial {
  constructor(public serialnumber?: string, public deviceName?: string) {}
}

export class SerialNumber {
  constructor(
    public id?: number,
    public serialnumber?: string,
    public devicetype?: string,
    public certificatePath?: string,
    public deviceId?: string,
    public article?: ArticleCode,
    public articleId?: number,
    public articleCode?: string,
    public description?: string,
    public warrantyExp?: Date,
    public installedBy?: string,
    public productionDate?: Date,
    public marketingConsent?: boolean,
    public warrantyStatus?: WarrantyStatus,
    public country?: string,
  ) {}
}

export class SerialNumbersImportStatus {
  constructor(
    public success?: boolean,
    public message?: string,
    public importedAt?: Date,
    public erroredRows?: number,
    public skippedRows?: number,
    public importedRows?: number,
    public currentSerialNumber?: string,
    public imported?: number,
    public error?: number,
    public skipped?: number,
    public importedSerialNumbers?: number,
    public erroredLines?: number,
    public skippedLines?: number,
    public remainingLines?: number
  ) {}
}

export interface ImportProgress {
  currentSerialNumber: string;
  imported: number;
  error: number;
  skipped: number;
  remaining: number;
  success: boolean;
}

export class SerialNumberUpdate {
  constructor(
    public serialnumber?: string,
    public certificatePath?: string,
    public deviceId?: string,
    public articleId?: number,
    public description?: string,
    public warrantyExp?: Date,
    public productionDate?: Date
  ) {}
}

export class SerialEditing {
  constructor(public bool: boolean, public id: number) {}
}

export class SubscribeSerialNumbers {
  constructor(public serialNumberIds?: number[], public userId?: number, public clear?: boolean) {}
}

export class SubscribeSerialNumber {
  constructor(public serialNumberId?: number, public userIds?: number[]) {}
}

export class UnsubscribeSerialNumber {
  constructor(public serialNumberId?: number, public userIds?: number[]) {}
}

export class SearchDevice {
  constructor(public id?: string, public serialNumber?: string, public name?: string, public tags?: Tag[]) {}
}

export enum DeviceType {
  AudioVideoTerminal = "audioVideoTerminal",
  Automation = "automation",
  Breaker = "breaker",
  Gateway = "gateway",
  ELC = "ELC",
  ELU = "ELU",
  Hygrometer = "hygrometer",
  Light = "light",
  Lock = "lock",
  Meter = "meter",
  Plug = "plug",
  Scene = "scene",
  Shutter = "shutter",
  Thermometer = "thermometer",
  Thermostat = "thermostat",
}

export enum WarrantyStatusDTO {
  UNDER_WARRANTY = "UNDER_WARRANTY",
  WARRANTY_EXPIRED = "WARRANTY_EXPIRED",
  WARRANTY_ALMOST_EXPIRED = "WARRANTY_ALMOST_EXPIRED",
}

export enum WarrantyStatus {
  ALL = "All",
  UNDER_WARRANTY = "device_under_warranty",
  WARRANTY_EXPIRED = "device_warranty_expired",
  WARRANTY_ALMOST_EXPIRED = "device_warranty_almost_expired",
}

export class DeviceHistory {
  constructor(public id?: number, public type?: HistoryType, public eventDate?: Date, public title?: string) {}
}

export enum HistoryType {
  MAINTENANCE = 0,
  INSTALLATION = 1,
  WARRANTY_EXPIRATION_UPDATED = 2,
  DEVICE_ACTIVATION = 3,
}

export interface WarrantyVersion {
  country: string;
  version: WarrantyVersionEnum;
}

export enum WarrantyVersionEnum {
  A = 0,
  B = 1,
}
